import React from 'react';

export const IndexMinimal = () => {
  return (
    <div className="min-h-screen bg-green-500 text-white flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">🇦🇷 Argentina Landing Page</h1>
        <p className="text-xl">Minimal version - If you see this, basic rendering works!</p>
        <p className="mt-4">This proves the Argentina landing page can render.</p>
        <div className="mt-8 p-4 bg-green-600 rounded-lg">
          <h2 className="text-2xl mb-2">BaseTemplate Features:</h2>
          <ul className="text-left">
            <li>✅ Clean gallery design</li>
            <li>✅ Argentina-specific CTAs</li>
            <li>✅ Tally form integration</li>
            <li>✅ Mobile responsive</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default IndexMinimal;